import { Provider, ProviderKey } from "@smart/bridge-providers-dom";
import { Loading, StatusOverlay } from "@smart/itops-sb-design-system-dom";
import { buildErrorCode } from "@smart/itops-utils-basic";

import { Display } from "./display";
import { Instructions } from "../components/instructions";
import { AuthApiResults, useAuthStep, useSRP } from "../hooks";

type LoginProps = {
  env: AuthApiResults["env"];
  provider: Provider<ProviderKey>;
  fragment?: { email?: string; response?: string };
  clear: () => void;
};

const Login = ({
  env: { awsRegion, smokeballUserPoolId, smokeballClientId },
  provider,
  fragment,
  clear,
}: LoginProps) => {
  const { step, hint, setStep, setEmail } = useAuthStep({
    region: awsRegion,
    clientId: smokeballClientId,
    provider,
  });
  const { loading, start, next, initial } = useSRP({
    setStep,
    setEmail,
    cognito: {
      autoConfirmDevice: true,
      autoRememberDevice: "remembered",
      region: awsRegion,
      clientId: smokeballClientId,
      userPoolId: smokeballUserPoolId,
    },
    initial: {
      username: fragment?.email,
    },
  });
  const errorCode = step
    ? step.error && buildErrorCode(step.error)
    : fragment?.response;

  return (
    <>
      {loading && <Loading />}
      {hint && (
        <Instructions
          image={provider.icon}
          alt={provider.label}
          onImageClick={clear}
        >
          {hint}
        </Instructions>
      )}
      {errorCode && <StatusOverlay status="error" errorCode={errorCode} />}
      <Display step={step} start={start} next={next} initial={initial} />
    </>
  );
};

export { Login, LoginProps };
